import { render } from "./Mujer.vue?vue&type=template&id=0d7d89ca"
import script from "./Mujer.vue?vue&type=script&lang=js"
export * from "./Mujer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__